import './FourColumnLayout.css';
import FourColumn from './FourColumn';
 
const FourColumnLayout = ({ data, certifClick }) => {
  return (
    <div className="container">
      <div className="row">
        {data.map((how, key) => (
          <FourColumn
            content={how}
            certifClick={certifClick}
            key={how.title + key}
          />
        ))}
      </div>
    </div>
  );
};

export default FourColumnLayout;
